/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { arrayOf, func, node, object, oneOf, oneOfType, string } from 'prop-types';
import { dt } from '../../../helpers/Utils/GetTailwindToken';

const List = ({ automationId, children, listClassName, itemClassName, itemRenderer, listType }) => {
    const renderLineItems = () => {
        let lineItems = null;

        if (itemRenderer) {
            lineItems = children.map((lineItem, index) => itemRenderer(lineItem, index));
        } else {
            lineItems =
                Array.isArray(children) &&
                children.map((lineItem, index) => {
                    const key = index;
                    const itemClasses = `font-open-sans text-small ${itemClassName}`.trim();

                    return (
                        <li className={itemClasses} key={key}>
                            {lineItem}
                        </li>
                    );
                });
        }
        return lineItems;
    };

    const RenderList = () => {
        let ListTag = 'ul';

        const listProps = {
            className: 'list-none',
        };

        if (listType !== 'none') {
            listProps.className = listType === 'decimal' ? 'list-decimal' : 'list-disc';
        }

        listProps.className =
            listType === 'none'
                ? (listProps.className = `${dt([listProps.className, 'ml-0', listClassName])}`)
                : (listProps.className = `${dt([listProps.className, 'ml-6', listClassName])}`);

        if (children.length > 0) {
            if (listType === 'decimal') {
                ListTag = 'ol';
            }

            return (
                <ListTag data-automation-id={automationId} {...listProps}>
                    {renderLineItems()}
                </ListTag>
            );
        }
        return null;
    };

    return <RenderList />;
};

List.propTypes = {
    /** An array of elements that are rendered as list line items */
    children: arrayOf(oneOfType([node, object, string])).isRequired,
    /** Automation ID */
    automationId: string,
    /** styles for the line items in the list */
    itemClassName: string,
    /** a custom renderer function for list line items, must return a node */
    itemRenderer: func,
    /** styles for the entire list */
    listClassName: string,
    /** sets list to ordered, bulleted, or unordered (none), default is unordered (none) */
    listType: oneOf(['decimal', 'disc', 'none']),
};

List.defaultProps = {
    automationId: null,
    itemClassName: '',
    itemRenderer: null,
    listClassName: '',
    listType: 'none',
};

export default List;
